/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unloanorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import useBorrowerData from '../common/hooks/useBorrowerData';
import { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';

type borrowerValue = {
  borrowerData: Record<string, BorrowerData>;
  currentBorrower: BorrowerData | null;
  primaryCoBorrowers: BorrowerDatas;
  loadingBorrowerData: boolean;
  fetchingBorrowerData: boolean;
  updateBorrowerData: (
    fields: Record<string, any>,
    setErrors: Dispatch<SetStateAction<Record<string, any>>>,
  ) => Promise<void>;
  reloadBorrowerData: VoidFunction;
  borrowerDataArr: BorrowerData[];
};

const BrwrContext = createContext<borrowerValue | null>(null);

const useBrwrContext = () => {
  const brwrContext = useContext(BrwrContext);
  if (brwrContext === undefined) {
    // throwing this error helps in development when the context is out of scope.
    throw new Error('brwrContext must be inside a BrwrProvider');
  }
  return brwrContext;
};

type loanProviderProps = {
  children: ReactNode;
};

const BrwrProvider = ({ children }: loanProviderProps): JSX.Element => {
  const { borrowerData, currentBorrower, primaryCoBorrowers, loadingBorrowerData, fetchingBorrowerData, updateBorrowerData, reloadBorrowerData, borrowerDataArr } =
    useBorrowerData();

  return (
    <BrwrContext.Provider
      value={{
        borrowerData,
        currentBorrower,
        primaryCoBorrowers,
        loadingBorrowerData,
        fetchingBorrowerData,
        updateBorrowerData,
        reloadBorrowerData,
        borrowerDataArr,
      }}
    >
      {children}
    </BrwrContext.Provider>
  );
};

export { BrwrProvider, useBrwrContext };
